<script setup lang="ts">
type Props = { isShowFullText?: boolean }

defineProps<Props>()

const { isDesktop } = useDevice()
</script>

<template>
  <the-button
    variant="secondary"
    class="button"
    href="https://farfor.ru/a/"
    font="sm"
    rel="nofollow"
  >
    <span v-if="isDesktop && !isShowFullText">Скачать</span>
    <span v-else>Скачать приложение</span>

    <nuxt-img
      class="button__image"
      width="16"
      height="16"
      src="/footer/footer-apple.svg"
      alt="Иконка Apple"
    />
    <nuxt-img
      class="button__image"
      width="16"
      height="16"
      src="/footer/footer-google-play.svg"
      alt="Иконка Google Play"
    />
    <nuxt-img
      class="button__image"
      width="16"
      height="16"
      src="/footer/footer-huawei.svg"
      alt="Иконка Huawei"
    />
  </the-button>
</template>

<style lang="scss" scoped>
.button {
  &__image {
    margin-left: 5px;
  }

  @include media('>=tablet') {
    max-width: 355px !important;
  }

  @include media('>desktop-mini') {
    margin-bottom: 20px;
  }
}
</style>
